import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// THUNK to load mentee logs
export const loadMenteeLogs = createAsyncThunk(
  "mentees/loadMenteeLogs",
  async ({ request, status = 4 }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_MENTEE_REQUEST}/${status}`,
        {
          params: {
            ...request,
            type: "past",  // important
          },
        }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      return {
        mentees: Array.isArray(data) ? data : [],
        pagination,
        notFound: data.length === 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load mentee logs");
    }
  }
);

export const loadRegMenteeLogs = createAsyncThunk(
  "mentees/loadMenteeLogs",
  async ({ request, status = 4 }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_REG_MENTEE_REQUEST}/${status}`,
        {
          params: {
            ...request,
            type: "past",  // important
          },
        }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};
      const steps_labels = response?.data?.data?.steps_labels || {};

      return {
        mentees: Array.isArray(data) ? data : [],
        pagination,
        steps_labels,
        notFound: data.length === 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load mentee logs");
    }
  }
);

const menteesLogSlice = createSlice({
  name: "menteesLog",
  initialState: {
    mentees: [],
    pagination: {},
    loading: false,
    error: null,
  },
  reducers: {
    resetMenteeLogs: (state) => {
      state.mentees = [];
      state.pagination = {};
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadMenteeLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadMenteeLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.mentees = action.payload.mentees;
        state.pagination = action.payload.pagination;
      })
      .addCase(loadMenteeLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMenteeLogs } = menteesLogSlice.actions;
export default menteesLogSlice.reducer;
